var Variants = /* @__PURE__ */ ((Variants2) => {
  Variants2["STACKED"] = "stacked";
  Variants2["COSTCO_INLINE"] = "costco-inline";
  return Variants2;
})(Variants || {});
export {
  Variants
};
